import app from 'flarum/common/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Alert from 'flarum/common/components/Alert';
import { extend } from 'flarum/common/extend';
import ItemList from 'flarum/common/utils/ItemList';

export default class BindModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);

    this.loading = false;
    this.error = null;
    this.captcha = Stream('');
    this.identification = Stream('');
    this.password = Stream('');
    this.need_captcha = false;
    this.current_identification = '';
  }

  className() {
    return 'BindModal Modal--small';
  }

  title() {
    return '绑定账号';
  }

  fields() {
    const items = new ItemList();

    items.add(
      'identification',
      <div className="Form-group">
        <input className="FormControl" name="identification" type="text" placeholder="学工号/账号" bidi={this.identification} required/>
      </div>,
      100
    );

    items.add(
      'password',
      <div className="Form-group">
        <input className="FormControl" name="password" type="password" placeholder="密码" bidi={this.password} required />
      </div>,
      90
    );

    items.add(
      'captcha-image',
      <div className="Form-group">
        <img
          className="Form-control--captcha"
          onclick={() => {
            this.$('.Form-control--captcha').attr('src', app.forum.attribute('apiUrl') + '/cjlu/auth/captcha?refresh=' + Date.now());
          }}
        />
      </div>,
      20
    );

    items.add(
      'captcha',
      <div className="Form-group">
        <input
          className="FormControl Form-control--captcha--input"
          name="captcha"
          type="text"
          placeholder="验证码"
          aria-label="验证码"
          bidi={this.captcha}
        />
      </div>,
      20
    );

    items.add(
      'submit',
      <div className="Form-group">
        <Button className="Button Button--primary Button--block" type="submit" loading={this.loading}>
          绑定
        </Button>
      </div>,
      -10
    );

    return items;
  }

  content() {
    return (
      <div className="Modal-body">
        <div className="Form Form--centered">{this.fields().toArray()}</div>
      </div>
    );
  }

  checkUser(value, callback = null) {
    if (!value) {
      return;
    }
    if (value === this.current_identification) {
      if (callback) {
        callback();
      }
      return;
    }
    this.current_identification = value;
    app
      .request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/cjlu/auth/check_user',
        body: {
          identification: value,
        },
      })
      .then((res) => {
        this.need_captcha = res.need_captcha;
        if (this.need_captcha) {
          $('.Form-control--captcha').css('display', 'block');
          $('.Form-control--captcha--input').css('display', 'block');
          $('.Form-control--captcha').attr('src', app.forum.attribute('apiUrl') + '/cjlu/auth/captcha?refresh=' + Date.now());
        } else {
          $('.Form-control--captcha').css('display', 'none');
          $('.Form-control--captcha--input').css('display', 'none');
        }
        if (callback) {
          callback();
        }
      });
  }

  bindParams = function () {
    const data = {
      identification: this.identification(),
      password: this.password(),
      captcha: this.captcha(),
    };

    return data;
  };

  onsubmit(e) {
    e.preventDefault();

    this.loading = true;

    this.checkUser(this.identification(), () => {
      if (this.need_captcha && !this.captcha()) {
        this.loading = false;
        app.alerts.show({ type: 'error' }, '请输入验证码');
        this.captcha('');
        $('.Form-control--captcha--input').focus();
        return;
      }
      app
        .request({
          method: 'POST',
          url: `${app.forum.attribute('apiUrl')}/cjlu/auth/bind`,
          body: this.bindParams(),
          errorHandler: this.onerror.bind(this),
        })
        .then((response) => {
          if (response.error === 1) {
            this.alertAttrs = { type: 'error', content: response.msg };
            this.loading = false;
            this.current_identification = '';
            m.redraw();
            return;
          }
          window.location.reload();
          this.loaded.bind(this);
        });
    });
  }
}
